import React from 'react';
import {
	ThemeProvider as MaterialThemeProvider,
	StyledEngineProvider,
	createTheme as createMaterialTheme,
} from '@mui/material/styles';
import StylesProvider from '@mui/styles/StylesProvider';
import { ConfigProvider } from 'antd';
import { getSubdomainBasedMapping } from 'app/helpers/subDomainHelpers';

const ThemeProvider = ({ children }) => {
	const mapping = getSubdomainBasedMapping();
	const primaryColor = mapping?.themecolor || '#03989e';

	const theme = createMaterialTheme({
		palette: {
			primary: { main: primaryColor },
		},
	});

	return (
		<StyledEngineProvider injectFirst>
			<MaterialThemeProvider theme={theme}>
				<ConfigProvider
					theme={{
						token: { colorPrimary: primaryColor },
					}}
				>
					<StylesProvider hashPriority="high">{children}</StylesProvider>
				</ConfigProvider>
			</MaterialThemeProvider>
		</StyledEngineProvider>
	);
};

export default ThemeProvider;
